@if (showSearch) {
  <div
    class="search"
    [style]="itemFont"
    [style.max-width.px]="alwaysOpen ? resultMaxWidth : null"
    [style.min-width.px]="alwaysOpen ? resultMinWidth : null"
    [style.background]="backgroundStyle && backgroundStyle.backgroundColor ? backgroundStyle.backgroundColor : null"
    [style.boxShadow]="boxShadow"
    [style.borderRadius.px]="borderRadius"
    [style.borderStyle]="border?.borderStyle"
    [style.borderWidth]="border?.borderWidth"
    [style.borderColor]="border?.borderColor"
    #searchContainer
    [class.focused]="searchFocused"
  >
    <input
      style="--inactive-opacity: {{ itemInactiveOpacity }}"
      #searchInput
      autocomplete="off"
      [(ngModel)]="query"
      (ngModelChange)="emitQueryChange($event)"
      (focus)="gotFocus()"
      [placeholder]="placeholder || 'Suche...'"
      (keyup.enter)="enterSearch($event)"
      (keyup.escape)="resetQuery()"
      (keyup.arrowup)="up()"
      (keyup.arrowdown)="down()"
      (ngModelChange)="searchChange(true)"
    />
    <div
      class="reset center flex aspect-square h-full"
      (mouseenter)="resetButtonHover = true"
      (mouseleave)="resetButtonHover = false"
      [class.show]="query.length > 1 && !isLoading"
      (click)="resetQuery()"
      [ngStyle]="resetButtonHover ? resetButtonHoverStyleOutput : resetButtonStyleOutput"
    >
      <i class="icon-{{ resetIcon || 'plus r45' }}"></i>
    </div>

    <div class="reset center pointer-events-none flex aspect-square h-full !p-1" [class.show]="isLoading" [ngStyle]="resetButtonStyleOutput">
      <div class="loader"></div>
    </div>
  </div>
}
@if (alwaysOpen) {
  <div class="items-list flex flex-1 flex-col">
    <ng-container *ngTemplateOutlet="searchResults"></ng-container>
  </div>
}

<ng-template #searchResults>
  @if (selectAllText && multiSelect && value && items && value.length < items.length) {
    <div [style]="itemFont" [@showButton] [class.minLineHeight]="minLineHeight" class="select-all-container" (click)="selectAll()">
      <!-- [style]="selectAllButtonStyle"
      [ngStyle]="selectAllButtonBackground" -->
      <div class="select-all-button">
        <span class="select-all-button-label">{{ selectAllText }}</span>
      </div>
    </div>
  }

  <div
    class="results"
    style="--inactive-opacity: {{ itemInactiveOpacity }}; --mouse-over-bg: {{ itemMouseOver.backgroundColor }}; --mouse-over-color: {{
      itemMouseOver.color
    }}; --active-color: {{ itemActive.color }}; --active-bg: {{ itemActive.backgroundColor }}"
    [class.flex]="flexed"
    [class.flex-1]="flexed"
    [class.alwaysOpen]="alwaysOpen"
    [class.minLineHeight]="minLineHeight || minLineHeightOnItems"
    [ngClass]="{ toTop: toTop }"
    [style.borderRadius.px]="showBorderRadiusOnResults ? borderRadius : null"
    [style.boxShadow]="showBoxshadowOnResults ? boxShadow : null"
    [style.background]="showBackgroundOnResults && backgroundStyle && backgroundStyle.backgroundColor ? backgroundStyle.backgroundColor : null"
    [style.borderStyle]="showBorderOnResult ? border?.borderStyle : null"
    [style.borderWidth]="showBorderOnResult ? border?.borderWidth : null"
    [style.borderColor]="showBorderOnResult ? border?.borderColor : null"
    [style.width.px]="resultWidth"
    [style.max-width.px]="resultMaxWidth"
    [style.min-width.px]="resultMinWidth"
    [style.max-height.px]="resultMaxHeight"
    [class.!opacity-0]="isLoading"
  >
    @if (!useVirtualScroll && (items | search: query : labelField); as searchResultItems) {
      <!-- [style]="itemFont" -->
      @for (item of searchResultItems | sort: sortByField || labelField : sortDesc : autoSort; track $index; let i = $index) {
        <div
          #results
          [ngClass]="{
            navSelected: i === navigateSelect,
            'px-2': !showCheckbox && !multiSelect,
          }"
          [class.active]="activeItem(item)"
          class="item"
        >
          @if (multiSelect || showCheckbox) {
            <div class="center checkbox-container flex" [style]="itemFont" (click)="selectItem($event, item, true, false)">
              <i class="icon-ok"></i>
              <!-- <div class="checkbox"></div> -->
            </div>
          }
          <div class="label" [style]="itemFont" (click)="selectItem($event, item, true, true)">
            <div class="label-text" innerHTML="{{ item[labelField] | highlight: query }}"></div>
            @if (subLabelField && item[subLabelField]) {
              <div class="opacity-80">{{ item[subLabelField] }}</div>
            }
          </div>
        </div>
      }
      @if (searchResultItems.length === 0 && noResultsMessage) {
        <div [style]="itemFont" class="item no-highlights">
          <div class="label">{{ noResultsMessage }}</div>
        </div>
      }
    }
    @if (useVirtualScroll && (items | search: query : labelField); as searchResultItems) {
      <cdk-virtual-scroll-viewport [itemSize]="itemSize" style="width: 100%" [style.minHeight]="virtualScrollHeight" [minBufferPx]="500" [maxBufferPx]="500">
        <!-- [style]="itemFont" -->
        <div
          #results
          *cdkVirtualFor="let item of searchResultItems | sort: sortByField || labelField : sortDesc : autoSort; let i = index; trackBy: trackByFn"
          [ngClass]="{ navSelected: i === navigateSelect }"
          [class.active]="activeItem(item)"
          class="item"
        >
          @if (multiSelect || showCheckbox) {
            <div class="center checkbox-container flex" [style]="itemFont" (click)="selectItem($event, item, true, false)">
              <i class="icon-ok"></i>
              <!-- <div class="checkbox"></div> -->
            </div>
          }
          <div class="label" [style]="itemFont" (click)="selectItem($event, item, true, true)">
            <div class="label-text" innerHTML="{{ item[labelField] | highlight: query }}"></div>
            @if (subLabelField && item[subLabelField]) {
              <div class="opacity-80">{{ item[subLabelField] }}</div>
            }
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    }
  </div>
</ng-template>

@if (!alwaysOpen) {
  <modal-overlay
    [originPosition]="originPosition"
    [overlayPosition]="overlayPosition"
    [withBackdrop]="false"
    [withShadow]="false"
    [withBluring]="false"
    [autoClose]="true"
    [autoSize]="true"
    [identifier]="modalId"
    [element]="searchContainer"
    [contentTemplate]="searchResults"
  ></modal-overlay>
}
